module.exports = __webpack_public_path__ + "static/media/1 6 tattoo chest medicine sigil epic.1280x1707.4cc57b7e.webp";